import { PageIntro } from "../components/site/PageIntro";
import { ImgReveal, FadeUp, Lines } from "../components/site/Reveal";
import { Btn } from "../components/site/Btn";
import { useSeo } from "../components/site/Seo";
import { useLang } from "../i18n/lang";
import { useSiteImages } from "../lib/siteImages";

export default function About() {
  const { t, to } = useLang();
  const img = useSiteImages();
  useSeo(...t.seo.about);
  const [first, ...rest] = t.about.paras;
  return (
    <main data-testid="about-page">
      <PageIntro n={0} label={t.about.label} title={t.about.title} testid="about-intro" />
      <section className="px-6 sm:px-10 lg:px-14 pb-24 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
        <div className="lg:col-span-5">
          <ImgReveal src={img("about")} alt="Natural stone detail" className="aspect-[4/5]" eager />
        </div>
        <div className="lg:col-span-6 lg:col-start-7 lg:pt-16">
          <FadeUp><p className="f-serif font-light text-3xl sm:text-4xl leading-[1.2] tracking-[-0.01em]" data-testid="about-lead">{first}</p></FadeUp>
          {rest.map((p, i) => (
            <FadeUp key={i} delay={0.1 * (i + 1)}><p className="mt-8 text-lg leading-[1.8] text-[#3A3A3A] max-w-xl">{p}</p></FadeUp>
          ))}
        </div>
      </section>
      <section className="bg-[#F0F0F0] px-6 sm:px-10 lg:px-14 py-24 sm:py-32">
        <ul className="space-y-2">
          {t.about.principles.map((p, i) => (
            <li key={p} className="border-b border-[#1A1A1A]/15 py-6 flex items-baseline gap-6">
              <span className="f-mono text-xs text-[#555555]">0{i + 1}</span>
              <Lines lines={[p]} as="p" className="f-serif italic font-light text-4xl sm:text-5xl lg:text-7xl tracking-[-0.02em]" />
            </li>
          ))}
        </ul>
        <div className="mt-16"><Btn to={to("/start-a-project")} testid="about-cta">{t.nav.inquire}</Btn></div>
      </section>
    </main>
  );
}
